// removed by extract-text-webpack-plugin
module.exports = {"published":"_32WGi1byDoiqxS_-QMynvk","frontpage":"_1s2bq6NLuZCpwo00_9XmaJ","horizontal":"_3byNsmyaWOn9oUALSmSQL","-is-feature-article":"_3safmw3xd9zjJ-gsrJXwFo","icon":"_31M1xMzR9jTDsvS-LPPmTA","text":"Fs5mKbdbaqN81TaWUJY7Y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Published/Published.module.scss
// module id = 801
// module chunks = 0